import { type ReactNode } from "react"
import { cn } from "../../lib/utils"

interface AlertProps {
  variant?: "info" | "success" | "warning" | "danger"
  children: ReactNode
  className?: string
}

export function Alert({ variant = "info", children, className }: AlertProps) {
  const variants = {
    info: "bg-blue-50 dark:bg-blue-900/30 border-blue-200 dark:border-blue-800 text-blue-900 dark:text-blue-200",
    success: "bg-brand-50 dark:bg-brand-900/30 border-brand-200 dark:border-brand-800 text-brand-900 dark:text-brand-200",
    warning: "bg-gold-50 dark:bg-gold-900/30 border-gold-200 dark:border-gold-800 text-gold-900 dark:text-gold-200",
    danger: "bg-red-50 dark:bg-red-900/30 border-red-200 dark:border-red-800 text-red-900 dark:text-red-200",
  }
  return (
    <div className={cn("border rounded-lg p-4", variants[variant], className)}>
      {children}
    </div>
  )
}
